import { EventJourneyStatus } from "@prisma/client";

export const getEventStatusColor = (status: EventJourneyStatus): string => {
    const colorMap = {
        DRAFT: "bg-v3-N400",
        PUBLISHED: "bg-v3-C400",
        ARCHIVED: "bg-v3-B300",
        DELETED: "bg-v3-R400",
        DRAFT_PROPOSED: "bg-v3-O500",
        PROPOSED: "bg-v3-P300",
        IGNORED: "bg-v3-S300",
    };

    return colorMap[status] || "bg-v3-N300";
};
